import { render, staticRenderFns } from "./ecBlogPage.vue?vue&type=template&id=39e6cf7d&lang=pug"
import script from "./ecBlogPage.vue?vue&type=script&lang=js"
export * from "./ecBlogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VSpacer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VSpacer.js').default,EcHexaButton: require('/home/runner/work/EC-Website/EC-Website/components/ecHexaButton.vue').default,VImg: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VImg/VImg.js').default,VCol: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VCol.js').default,VChip: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VChip/VChip.js').default,VRow: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VRow.js').default,VFlex: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VFlex.js').default,VCard: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VCard/VCard.js').default,VPagination: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VPagination/VPagination.js').default,VContainer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VContainer.js').default})
